import {
  alphaNum as alphaNumber,
  email as mail,
  helpers,
  required as require,
  requiredIf as requireIf,
  minValue as min,
  maxValue as max,
  minLength as minLen,
  numeric as num,
  sameAs,
  url,
  integer as int,
} from '@vuelidate/validators';

export const account = helpers.withMessage(
  '登入帳號限使用英文字母、數字或符號',
  // eslint-disable-next-line no-control-regex
  helpers.regex(/^[\x00-\x1F|\x21-\x7F]+$/),
);
export const alphaNum = helpers.withMessage('僅能輸入英文及數字', alphaNumber);
export const email = helpers.withMessage('電子郵件格式錯誤', mail);
export const identification = helpers.withMessage(
  '統一編號必須為8碼數字',
  helpers.regex(/^\d{8}$/),
);
export const password = helpers.withMessage(
  '密碼限8個字元以上，並且必須包含英文字母及數字',
  helpers.regex(/^(?=.{8,})(?=.*\d)(?=.*[a-z]+|[A-Z]+)(?=.*[@#_$%^&+=]?).*$/),
);
export const phone = helpers.withMessage(
  '電話號碼格式錯誤',
  helpers.regex(/^[+?\-#*()\d]+$/),
);
export const mobile = helpers.withMessage(
  '手機號碼格式錯誤，僅能輸入數字、+ 和 -',
  helpers.regex(/^\+?\d*-?\d+$/),
);

export const required = (field) => helpers.withMessage(`${field}為必填`, require);
export const sameAsPassword = (pwd) => helpers.withMessage('您輸入的兩個密碼並不相符，請再試一次', sameAs(pwd()));
export const requiredIf = (field, condition) => helpers.withMessage(`${field}為必填`, requireIf(condition));
export const minValue = (field, value = 0) => helpers.withMessage(`${field}不得小於 ${value}`, min(value));
export const maxValue = (field, value = Number.MAX_SAFE_INTEGER) => helpers.withMessage(`${field}不得大於 ${value}`, max(value));
export const minLength = (field, value = 1) => helpers.withMessage(`至少需要${value}個${field}`, minLen(value));
export const numeric = helpers.withMessage('僅能輸入數字', num);
export const isUrl = (field) => helpers.withMessage(`${field}格式錯誤`, url);
export const integer = (field) => helpers.withMessage(`${field}必需是整數`, int);

export default {
  account,
  alphaNum,
  email,
  password,
  phone,
  mobile,
  numeric,
  required,
  requiredIf,
  sameAsPassword,
  minValue,
  maxValue,
  minLength,
  isUrl,
  integer,
};
